'use client';

import { useEffect } from 'react';
import { usePathname, useSearchParams } from 'next/navigation';

export default function GtmPageView() {
  const pathname = usePathname();
  const searchParams = useSearchParams();

  useEffect(() => {
    const handlePageView = () => {
      const url =
        pathname +
        (searchParams.toString() ? `?${searchParams.toString()}` : '');

      if (typeof window !== 'undefined' && window.dataLayer) {
        window.dataLayer.push({
          event: 'page_view',
          page_path: url,
          page_location: window.location.href,
          page_title: document.title,
        });
        // console.log('Sent manual page_view:', url);
      }
    };

    handlePageView();
  }, [pathname, searchParams]);

  return null;
}
